export default "__VITE_ASSET__COTGeit8__"